<template>
  <div id="stemp">
    <el-row :gutter="20">
      <el-col v-for="(item,key) in data" :key="item" :span="6">
        <div class="round-list">
          <span>{{ key + 1 }}</span>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
export default {
  data() {
    return {
      data: []
    }
  },
  props: {
    dataList: Array
  },
  mounted() {
    this.data = this.dataList
    console.log(this.data)
  }
}
</script>
<style lang="scss">
#stemp {
  .round-list {
    width: 54px;
    height: 54px;
    background: rgba(255, 255, 255, 1);
    border: 2px solid rgba(221, 221, 221, 1);
    border-radius: 50%;
    display: flex;
    justify-content: center;
    span {
      line-height: 54px;
      font-size: 26px;
      font-family: Microsoft YaHei;
      font-weight: bold;
      color: rgba(221, 221, 221, 1);
    }
  }
  .round-list-active {
    width: 54px;
    height: 54px;
    background-color: #e2211c;
    border-radius: 50%;
    display: flex;
    justify-content: center;
    span {
      font-size: 26px;
      font-family: Microsoft YaHei;
      font-weight: bold;
      color: rgba(255, 255, 255, 1);
      line-height: 54px;
    }
  }
}
</style>